import React, { useMemo, useState } from "react";
import SettingsIcon from "@mui/icons-material/Settings";
import { IconButton, Switch } from "@mui/material";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { getDir } from "orion-components/i18n/Config/selector";
import {
	// Video, Bookmark, Export,
	JumpTime
} from "orion-components/CBComponents/Icons";
import { getTranslation } from "orion-components/i18n";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import { makeStyles } from "@mui/styles";
import JumpToDifferentTime from "./JumpToDifferentTime/JumpToDifferentTime";
import EventBus from "orion-components/SharedComponents/EventBus";

const useStyles = makeStyles({
	thumbOff: {
		backgroundColor: "#ffffff"
	},
	trackOff: {
		backgroundColor: "#828283",
		opacity: 1
	},
	thumbSwitched: {
		backgroundColor: "#29B6F6"
	},
	trackSwitched: {
		backgroundColor: "#bee1f1!important",
		opacity: "1!important"
	}
});

const SettingsMenu = ({ instanceId, toggleSettingsMenu, setVideoDurationExternally, setStartDateExternally }) => {
	const classes = useStyles();

	const [displayMenu, setDisplayMenu] = useState(null);
	const [toggleControls, setToggleControls] = useState(true);
	const dir = useSelector(state => getDir(state));
	const [displayJumpToTimeMenu, setDisplayJumpToTimeMenu] = useState(false);

	const styles = useMemo(() => {
		return {
			menuIcons: {
				...(dir === "ltr" && { paddingLeft: 4 }),
				...(dir === "ltr" && { paddingRight: 4 })
			}
		};
	}, [dir]);

	const menuItems = [
		{
			id: 1,
			canAccessMenu: true,
			item: toggleControls
				? getTranslation("global.CBComponents.newVideoPlayer.components.recorded.settingsMenu.showAlarms")
				: getTranslation("global.CBComponents.newVideoPlayer.components.recorded.settingsMenu.hideAlarms"),
			icon: toggleControls ? (
				<VisibilityIcon sx={{ width: 18.66, height: 18.66, color: "#4DB5F4" }} />
			) : (
				<VisibilityOffIcon sx={{ width: 18.66, height: 18.66, color: "#948E8E" }} />
			),
			action: () => {
				setToggleControls(!toggleControls);
				EventBus.publish("toggleAlertVisiblityOnTimeLine", { instanceId, value: !toggleControls });
			},
			hasNestedMenu: false,
			hasSwitch: true
		},
		{
			id: 2,
			item: "divider"
		},
		{
			id: 3,
			canAccessMenu: true,
			item: getTranslation("global.CBComponents.newVideoPlayer.components.recorded.settingsMenu.jump"),
			icon: (
				<div style={styles.menuIcons}>
					<JumpTime />
				</div>
			),
			action: () => {
				setDisplayJumpToTimeMenu(false);
				setDisplayJumpToTimeMenu(true);
			}
		}
		// {
		// 	id: 4,
		// 	canAccessMenu: true,
		// 	item: getTranslation("global.CBComponents.newVideoPlayer.components.recorded.settingsMenu.saveClip"),
		// 	icon: (
		// 		<div style={styles.menuIcons}>
		// 			<Video />
		// 		</div>
		// 	),
		// 	action: () => {
		// 		return null;
		// 	}
		// },
		// {
		// 	id: 5,
		// 	canAccessMenu: true,
		// 	item: getTranslation("global.CBComponents.newVideoPlayer.components.recorded.settingsMenu.saveBookMark"),
		// 	icon: (
		// 		<div style={styles.menuIcons}>
		// 			<Bookmark />
		// 		</div>
		// 	),
		// 	action: () => {
		// 		return null;
		// 	}
		// },
		// {
		// 	id: 6,
		// 	canAccessMenu: true,
		// 	item: getTranslation("global.CBComponents.newVideoPlayer.components.recorded.settingsMenu.export"),
		// 	icon: (
		// 		<div style={styles.menuIcons}>
		// 			<Export />
		// 		</div>
		// 	),
		// 	action: () => {
		// 		return null;
		// 	}
		// }
	];

	const handlePopoverClose = () => {
		setDisplayMenu(null);
		if (!displayJumpToTimeMenu) {
			toggleSettingsMenu(false);
		}
	};

	return (
		<div dir={dir} style={{ zIndex: 1 }}>
			<div style={{ width: 16.2, height: "100%" }}>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						width: "100%",
						height: "100%"
					}}
				>
					<IconButton
						sx={{ height: 16.2 }}
						onClick={() => {
							toggleSettingsMenu(true);
							setDisplayMenu(true);
						}}
					>
						<SettingsIcon sx={{ color: "#FFFFFF" }} />
					</IconButton>
				</div>
			</div>
			{displayJumpToTimeMenu && (
				<JumpToDifferentTime
					open={displayJumpToTimeMenu}
					instanceId={instanceId}
					closePopup={() => {
						setDisplayJumpToTimeMenu(false);
					}}
					position="right"
					setVideoDurationExternally={setVideoDurationExternally}
					setStartDateExternally={setStartDateExternally}
				/>
			)}
			<div
				style={{
					display: displayMenu !== null ? "block" : "none",
					position: "absolute",
					bottom: 0,
					...(dir === "ltr" && { right: 15 }),
					...(dir === "rtl" && { left: 15 }),
					color: "#fff",
					zIndex: 10
				}}
				onMouseLeave={handlePopoverClose}
			>
				<div
					style={{
						width: 160,
						minHeight: 120,
						maxHeight: 220,
						overflowY: "auto",
						backgroundColor: "#232223",
						borderRadius: 6,
						boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
						padding: "8px 0"
					}}
				>
					{menuItems.map((value, index) => {
						if (value.item !== "divider") {
							if (value.canAccessMenu) {
								return (
									<div
										key={index}
										className="bcc-main-menu"
										onClick={value.action}
										style={{
											display: "flex",
											flexDirection: "row",
											alignItems: "center",
											padding: "5px 5px",
											cursor: "pointer",
											fontSize: 10,
											gap: 12
										}}
									>
										<div style={{ flex: "0 0 24px", display: "flex", alignItems: "center" }}>
											{value.icon}
										</div>
										<div style={{ flex: "1 1 auto", display: "flex", alignItems: "center" }}>
											<span>{value.item}</span>
										</div>
										{value.hasSwitch && (
											<IconButton sx={{ marginLeft: "auto", padding: 0 }}>
												<Switch
													size="small"
													edge="end"
													onChange={value.action}
													checked={toggleControls}
													classes={{
														thumb: toggleControls
															? classes.thumbSwitched
															: classes.thumbOff,
														track: toggleControls ? classes.trackSwitched : classes.trackOff
													}}
												/>
											</IconButton>
										)}
									</div>
								);
							}
						} else {
							return (
								<div
									key={index}
									style={{
										width: "90%",
										height: 1,
										backgroundColor: "#444",
										margin: "8px auto"
									}}
								></div>
							);
						}
					})}
				</div>
			</div>
		</div>
	);
};

const defaultProps = {
	toggleSettingsMenu: () => {}
};

SettingsMenu.propTypes = {
	instanceId: PropTypes.string,
	toggleSettingsMenu: PropTypes.func
};
SettingsMenu.defaultProps = defaultProps;

export default SettingsMenu;
